import React, { useState } from "react";
import { Navbar, Container, Nav, Dropdown, Modal, Button } from "react-bootstrap";
import {
  FaBars,
  FaHome,
  FaPrint,
  FaQuestionCircle,
  FaUser,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../styles/TopNavBar.css";

function TopNavBar({ onToggleSidebar }) {
  const navigate = useNavigate();

  const role = localStorage.getItem("userRole");
  const user = JSON.parse(localStorage.getItem("user"));
  const loggedInUserId = localStorage.getItem("userId");
  const isAdmin = role === "1" || user?.role === "admin";

  const [showSupportModal, setShowSupportModal] = useState(false);
  const [showConfirmReturn, setShowConfirmReturn] = useState(false);

  const handleSupportOpen = () => setShowSupportModal(true);
  const handleSupportClose = () => setShowSupportModal(false);

  return (
    <>
      <Navbar variant="dark" fixed="top" className="top-nav-bar shadow-sm">
        <Container className="top-nav-container">
          <Nav className="d-flex gap-4">
            {isAdmin && onToggleSidebar && (
              <Nav.Link className="nav-icon" onClick={onToggleSidebar}>
                <div className="icon">
                  <FaBars />
                </div>
                <div className="label">Menu</div>
              </Nav.Link>
            )}
            <Nav.Link
              onClick={() => {
                const pathMatch =
                  window.location.pathname.match(/\/(?:[a-z-]+)\/(\d+)/);
                const viewedUserId = pathMatch?.[1];

                if (isAdmin && viewedUserId && viewedUserId !== loggedInUserId) {
                  setShowConfirmReturn(true);
                } else if (isAdmin) {
                  navigate("/admin");
                } else {
                  navigate("/userhome");
                }
              }}
              className="nav-icon"
            >
              <div className="icon">
                <FaHome />
              </div>
              <div className="label">Home</div>
            </Nav.Link>
            <Nav.Link onClick={() => window.print()} className="nav-icon">
              <div className="icon">
                <FaPrint />
              </div>
              <div className="label">Print</div>
            </Nav.Link>
          </Nav>

          <img src="/logoMain.png" alt="Logo" height="36" />

          <Nav className="d-flex gap-4">
            <Dropdown align="start">
              <Dropdown.Toggle as={Nav.Link} className="nav-icon">
                <div className="icon">
                  <FaQuestionCircle />
                </div>
                <div className="label">Help</div>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={handleSupportOpen}>Support</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Dropdown align="end">
              <Dropdown.Toggle as={Nav.Link} className="nav-icon">
                <div className="icon">
                  <FaUser />
                </div>
                <div className="label">My Account</div>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    if (isAdmin) {
                      navigate(`/edit-user/${loggedInUserId}`);
                    } else {
                      navigate("/profile");
                    }
                  }}
                >
                  My Account
                </Dropdown.Item>
                {localStorage.getItem("userRole") === "1" && (
                  <Dropdown.Item onClick={() => navigate("/admin")}>
                    Admin Page
                  </Dropdown.Item>
                )}
                <Dropdown.Item
                  onClick={() => {
                    localStorage.clear();
                    navigate("/");
                  }}
                >
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Container>
      </Navbar>

      <Modal show={showSupportModal} onHide={handleSupportClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Support Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            For information about your application or other questions, contact
            <br />
            <strong>New Way Transport Inc.</strong> at{" "}
            <a href="tel:7083231740">708-323-1740</a> or{" "}
            <a href="mailto:hr@newwaytrucking.com">hr@newwaytrucking.com</a>
          </p>
          <p>
            To receive technical support, please contact
            <br />
            <strong>IT team</strong> at <a href="tel:15873556767">587-355-6767</a>{" "}
            or <a href="mailto:it@newwaytrucking.com">it@newwaytrucking.com</a>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleSupportClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showConfirmReturn}
        onHide={() => setShowConfirmReturn(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Return to Your Admin Page?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to return to admin page? You are currently
          viewing another employee profile.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmReturn(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setShowConfirmReturn(false);
              if (isAdmin) {
                navigate("/admin");
              } else {
                navigate("/userhome");
              }
            }}
          >
            Yes, Return
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default TopNavBar;
